<div class="flex flex-col flex-auto w-full">

    <div class="flex flex-wrap w-full max-w-screen-xl mx-auto p-6 md:p-8" *ngIf="configured">
        <div class="flex items-center justify-between w-full">
            <div>
                <h2 class="text-3xl font-semibold tracking-tight leading-8">Indicadores clave</h2>
                <!-- <p>Keep track of your financial status</p> -->
            </div>
            <div class="flex items-center gap-x-2"> <!-- gap-x-2 agrega un pequeño espacio entre los elementos -->
                <div class="flex-auto">
                    <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full min-w-50">
                        <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:search'"></mat-icon>
                        <input matInput [formControl]="busquedaGeneral" required (keyup.enter)="searchGeneral()"
                            [placeholder]="'Buscar por Folio, RFC o Razón Social'">

                    </mat-form-field>
                </div>
                <mat-form-field>
                    <mat-select (selectionChange)="onSelectionChangeTipoComprobante($event)"
                        [placeholder]="'Tipo comprobante'" [formControl]="frmDocumento">
                        <mat-option value="{{item.id}}"
                            *ngFor="let item of tipoComprobante">{{item.attributes.nombre}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="flex items-center justify-between w-full mt-4">
            <div class="flex items-center">
                <button class="hidden sm:inline-flex mr-3"
                    [color]="selectedPeriod === Period.CurrentMonth ? 'primary' : undefined" mat-flat-button
                    (click)="setPeriod(Period.CurrentMonth)">
                    <span class="ml-2">Mes actual</span>
                </button>
                <button class="hidden sm:inline-flex mr-3" mat-flat-button
                    [color]="selectedPeriod === Period.PreviousMonth ? 'primary' : undefined"
                    (click)="setPeriod(Period.PreviousMonth)">
                    <span class="ml-2">Mes anterior</span>
                </button>
                <button class="hidden sm:inline-flex mr-3" mat-flat-button
                    [color]="selectedPeriod === Period.CurrentYear ? 'primary' : undefined"
                    (click)="setPeriod(Period.CurrentYear)">
                    <span class="ml-2">Año actual</span>
                </button>
                <button class="hidden sm:inline-flex mr-3" mat-flat-button
                    [color]="selectedPeriod === Period.PreviousYear ? 'primary' : undefined"
                    (click)="setPeriod(Period.PreviousYear)">
                    <span class="ml-2">Año anterior</span>
                </button>

            </div>
            <div class="form-container">
                <div class="form-row">
                    <mat-form-field class="year-select">
                        <mat-select 
                            [placeholder]="'Año'" 
                            [formControl]="frmAnio" 
                            (selectionChange)="onYearChange($event)">
                            <mat-option value="{{item}}" *ngFor="let item of anios">{{item}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="month-select">
                        <mat-select [placeholder]="'Mes'" [formControl]="frmMes">
                            <mat-option value="todos">Todos</mat-option>
                            <mat-option value="{{item}}" *ngFor="let item of meses">{{item}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <button 
                        mat-icon-button 
                        [disabled]="!frmAnio.value || !frmMes.value" 
                        color="primary" 
                        class="search-button" 
                        (click)="openSlide()">
                        <mat-icon svgIcon="heroicons_outline:magnifying-glass"></mat-icon>
                    </button>
                </div>
            </div>
            
        </div>

        <div class="flex items-center justify-between w-full mt-4">
            <h2 class="text-3xl font-semibold tracking-tight leading-8">Periodo de consulta: {{ fechaFiltro }}</h2>
        </div>

        <div class="grid grid-cols-1 xl:grid-cols-5 gap-8 w-full mt-8">
            <div class="xl:col-span-3">
                <!-- Totales Facturado -->
                <div class="flex flex-col bg-white rounded-lg shadow overflow-hidden h-full">
                    <div class="p-6">
                        <div class="flex flex-col">
                            <div class="text-lg font-medium tracking-tight leading-6 truncate">Facturado</div>
                        </div>
                        <div class="flex justify-between items-start mt-5">
                            <div class="flex flex-col">
                                <div class="text-sm font-medium">Total</div>
                                <div (click)="verDetalle('1', '2', null, '0')" style="cursor: pointer;"
                                    class="font-bold text-5xl">{{ invoiceTotal | currency:'MXN' }}</div>
                            </div>
                            <div class="flex flex-col items-center">
                                <div class="text-sm font-medium">Vigente</div>
                                <div (click)="verDetalle('1', '2', null, '0')" style="cursor: pointer;"
                                    class="text-4xl">{{
                                    porcentajesTotales.activas | number:'1.2-2' }}%</div>
                            </div>
                            <div class="flex flex-col items-center">
                                <div class="text-sm font-medium">Cancelado</div>
                                <div (click)="verDetalle('1', '3', null, '0')" style="cursor: pointer;"
                                    class="text-4xl">{{
                                    porcentajesTotales.canceladas | number:'1.2-2' }}%</div>
                            </div>
                        </div>

                        <div class="mt-10">
                            <div class="row" style="cursor: pointer;"
                                (click)="verDetalle(null,null, '/cuenta/perfil?key=plan-billing', '0')">
                                <div class="col-6">
                                    <div class="text-sm font-medium mr-2 text-blue-600">
                                        <b>Paquete actual</b>
                                    </div>
                                </div>
                                <div class="col-6 d-flex justify-content-end">
                                    <div class="text-sm font-medium mr-2">
                                        <b>{{ resumen.folios }} Folios</b>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="borde-progress">
                                        <mat-progress-bar *ngIf="showBar" mode="determinate"
                                            [value]="resumen.porcentaje" [color]="'info'"></mat-progress-bar>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="text-sm font-medium mr-2 text-blue-600">
                                        <b>{{ resumen.porcentaje | number:'1.2-2' }}%</b>
                                    </div>
                                </div>
                                <div class="col-6 d-flex justify-content-end">
                                    <div class="text-sm font-medium mr-2">
                                        <b>{{ resumen.disponibles }} Disponibles</b>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="xl:col-span-2">
                <!-- Total por comprobante -->
                <div class="flex flex-col bg-white rounded-lg shadow overflow-hidden h-full">
                    <div class="p-6">
                        <div class="flex flex-col">
                            <div class="text-lg font-medium tracking-tight leading-6 truncate">Por tipo de comprobante
                            </div>
                        </div>
                        <ng-container *ngIf="dataPorComprobante?.length != 0">
                            <apx-chart class="flex flex-auto items-center justify-center w-full h-full"
                                [chart]="byInvoiceType?.chart" [colors]="byInvoiceType?.colors"
                                [labels]="byInvoiceType?.labels" [plotOptions]="byInvoiceType?.plotOptions"
                                [series]="byInvoiceType?.series" [states]="byInvoiceType?.states"
                                [tooltip]="byInvoiceType?.tooltip" [dataLabels]="byInvoiceType?.dataLabels"></apx-chart>
                        </ng-container>

                        <ng-container *ngIf="dataPorComprobante?.length == 0">
                            <div
                                class="flex flex-col flex-auto items-center justify-center bg-gray-100 dark:bg-transparent">
                                <mat-icon class="icon-size-18 mt-5"
                                    [svgIcon]="'heroicons_outline:chart-pie'"></mat-icon>
                                <div class="mt-4 text-xl text-center font-semibold tracking-tight text-secondary mb-8">
                                    Aún no cuenta con información en <br>este periodo seleccionado.</div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>

            <div class="xl:col-span-3">
                <!-- Totales por cliente -->
                <div class="flex flex-col bg-white rounded-lg shadow overflow-hidden h-full">
                    <div class="p-6">
                        <div class="flex flex-col">
                            <div class="text-lg font-medium tracking-tight leading-6 truncate">Por cliente</div>
                        </div>
                        <div class="my-8 space-y-8">
                            <ng-container *ngIf="dataPorCliente?.length != 0">
                                <div class="flex flex-col mb-4">
                                    <div class="flex items-center">
                                        <div class="flex items-center justify-center w-7 h-7 rounded-full">
                                            <span class="font-bold text-xl">#</span>
                                        </div>
                                        <div class="w-1/4 min-w-1/4 ml-4 leading-none"> <!-- Ajusta la anchura aquí -->
                                            <div class="text-sm font-medium text-secondary">Cliente</div>
                                        </div>
                                        <div class="w-1/4 ml-4 leading-none">
                                            <div class="text-sm font-medium text-secondary text-right">Facturas</div>
                                        </div>
                                        <div class="w-1/2 ml-4 leading-none">
                                            <div class="text-sm font-medium text-secondary">Total</div>
                                        </div>
                                    </div>
                                </div>
                                <div *ngFor="let cliente of dataPorCliente; let i = index" class="flex flex-col mb-4">
                                    <div class="flex items-center">
                                        <div
                                            class="flex items-center justify-center w-7 h-7 rounded-full bg-red-100 text-red-800 dark:bg-red-600 dark:text-red-50">
                                            <span class="font-bold text-xl">{{ cliente.rowIndex }}</span>
                                        </div>
                                        <div (click)="verDetalle('1', '2', null, cliente.rfc)" style="cursor: pointer;"
                                            class="w-1/4 min-w-1/4 ml-4 leading-none"> <!-- Ajusta la anchura aquí -->
                                            <div class="mt-2 font-medium text-md truncate">{{ cliente.cliente }}</div>
                                        </div>
                                        <div class="w-1/4 ml-4 leading-none">
                                            <div class="mt-2 font-medium text-md text-right">{{ cliente.total }}</div>
                                        </div>
                                        <div class="w-1/2 ml-4 leading-none">
                                            <div class="mt-2 font-medium text-sm">{{cliente.sumaTotal | currency:'MXN'}}
                                            </div>
                                            <mat-progress-bar class="mt-3 rounded-full" [mode]="'determinate'"
                                                [value]="cliente.porcentaje"></mat-progress-bar>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>

                            <ng-container *ngIf="dataPorCliente?.length == 0">
                                <div
                                    class="flex flex-col flex-auto items-center justify-center bg-gray-100 dark:bg-transparent">
                                    <mat-icon class="icon-size-18 mt-5"
                                        [svgIcon]="'heroicons_outline:users'"></mat-icon>
                                    <div
                                        class="mt-4 text-xl text-center font-semibold tracking-tight text-secondary mb-8">
                                        Aún no cuenta con información en <br>este periodo seleccionado.</div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
            <div class="xl:col-span-2">
                <!-- Top de productos -->
                <div class="flex flex-col bg-white rounded-lg shadow overflow-hidden h-full">
                    <div class="p-6">
                        <div class="flex flex-col">
                            <div class="text-lg font-medium tracking-tight leading-6 truncate">TOP de productos</div>
                        </div>
                        <ng-container *ngIf="dataPorProducto?.length != 0">
                            <apx-chart class="flex flex-auto items-center justify-center w-full h-full"
                                [chart]="byProduct?.chart" [colors]="byProduct?.colors" [labels]="byProduct?.labels"
                                [plotOptions]="byProduct?.plotOptions" [series]="byProduct?.series"
                                [states]="byProduct?.states" [tooltip]="byProduct?.tooltip"
                                [dataLabels]="byProduct?.dataLabels"></apx-chart>
                        </ng-container>

                        <ng-container *ngIf="dataPorProducto?.length == 0">
                            <div
                                class="flex flex-col flex-auto items-center justify-center bg-gray-100 dark:bg-transparent">
                                <mat-icon class="icon-size-18 mt-5"
                                    [svgIcon]="'heroicons_outline:chart-pie'"></mat-icon>
                                <div class="mt-4 text-xl text-center font-semibold tracking-tight text-secondary mb-8">
                                    Aún no cuenta con información en <br>este periodo seleccionado.</div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <div class="grid grid-cols-1 xl:grid-cols-5 gap-8 w-full mt-8" *ngIf="verGrafica">
            <div class="xl:col-span-5">
                <!-- Grid de lo facturado vs cancelado -->
                <div class="flex flex-col bg-white rounded-lg shadow overflow-hidden h-full">
                    <div class="p-6">
                        <div class="flex flex-col mb-5">
                            <div class="text-lg font-medium tracking-tight leading-6 truncate">Registro de facturas
                            </div>
                        </div>
                        <ng-container *ngIf="!verImagenRegistroFacturas">
                            <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart"
                                [xaxis]="chartOptions.xaxis" [markers]="chartOptions.markers"
                                [stroke]="chartOptions.stroke" [yaxis]="chartOptions.yaxis"
                                [dataLabels]="chartOptions.dataLabels" [title]="chartOptions.title"
                                [fill]="chartOptions.fill" [tooltip]="chartOptions.tooltip"
                                [colors]="byInvoiceType?.colors" [legend]="chartOptions.legend"></apx-chart>
                        </ng-container>
                        <ng-container *ngIf="verImagenRegistroFacturas">
                            <div
                                class="flex flex-col flex-auto items-center justify-center bg-gray-100 dark:bg-transparent">
                                <mat-icon class="icon-size-18 mt-5" [svgIcon]="'heroicons_outline:users'"></mat-icon>
                                <div class="mt-4 text-xl text-center font-semibold tracking-tight text-secondary mb-8">
                                    Aún no cuenta con información en <br>este periodo seleccionado.</div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <div class="grid grid-cols-1 xl:grid-cols-5 gap-8 w-full mt-8" *ngIf="verGrafica">
            <div class="xl:col-span-5">
                <!-- Grid de resumen de impuestos federales -->
                <div class="flex flex-col bg-white rounded-lg shadow overflow-hidden h-full">
                    <div class="p-6">
                        <div class="flex flex-col mb-5">
                            <div class="text-lg font-medium tracking-tight leading-6 truncate">Resumen de impuesto
                                federales
                            </div>
                        </div>
                        <ng-container *ngIf="dataTaxes.grafica?.length != 0">
                            <div class="row">
                                <div class="col-sm-12">
                                    <apx-chart [series]="chartOptionsTaxes.series" [chart]="chartOptionsTaxes.chart"
                                        [dataLabels]="chartOptionsTaxes.dataLabels"
                                        [plotOptions]="chartOptionsTaxes.plotOptions" [xaxis]="chartOptionsTaxes.xaxis"
                                        [stroke]="chartOptionsTaxes.stroke" [fill]="chartOptionsTaxes.fill"
                                        [yaxis]="chartOptionsTaxes.yaxis" [title]="chartOptionsTaxes.title"
                                        [tooltip]="chartOptionsTaxes.tooltip" [legend]="chartOptionsTaxes.legend"
                                        [colors]="byInvoiceType?.colors"></apx-chart>
                                </div>
                            </div>
                            <div class="grid grid-cols-1 xl:grid-cols-5 gap-8 w-full mt-8">
                                <div class="xl:col-span-3">
                                    <div class="row">
                                        <div class="col-sm-1"></div>
                                        <div class="col-sm-5">
                                            <!-- Trasladados -->
                                            <h5>Trasladados</h5>
                                            <div class="flex flex-col mb-4">
                                                <div class="flex items-center">
                                                    <div class="flex items-center justify-center w-7 h-7 rounded-full">
                                                        <span class="font-bold text-xl">#</span>
                                                    </div>
                                                    <div class="w-1/4 min-w-1/4 ml-4 leading-none">
                                                        <!-- Ajusta la anchura aquí -->
                                                        <div class="text-sm font-medium text-secondary">Impuesto</div>
                                                    </div>
                                                    <div class="w-1/4 ml-4 leading-none">
                                                        <div class="text-sm font-medium text-secondary text-right">
                                                            TasaOFactor</div>
                                                    </div>
                                                    <div class="w-1/2 ml-4 leading-none">
                                                        <div class="text-sm font-medium text-secondary text-right">Total
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="flex flex-col mb-4"
                                                *ngFor="let taxes of dataTaxes.traslados; let i = index">
                                                <div class="flex items-center">
                                                    <div
                                                        class="flex items-center justify-center w-7 h-7 rounded-full bg-red-100 text-red-800 dark:bg-red-600 dark:text-red-50">
                                                        <span class="font-bold text-xl">{{ taxes.clave }}</span>
                                                    </div>
                                                    <div (click)="verDetalle('1', '2', null, cliente.rfc)"
                                                        style="cursor: pointer;"
                                                        class="w-1/4 min-w-1/4 ml-4 leading-none">
                                                        <!-- Ajusta la anchura aquí -->
                                                        <div class="mt-2 font-medium text-md truncate">{{ taxes.impuesto
                                                            }}</div>
                                                    </div>
                                                    <div class="w-1/4 ml-4 leading-none">
                                                        <div class="mt-2 font-medium text-md text-right">{{ taxes.tasa
                                                            }}</div>
                                                    </div>
                                                    <div class="w-1/2 ml-4 leading-none">
                                                        <div class="mt-2 font-medium text-sm text-right">{{ taxes.total
                                                            | currency:'MXN'}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="flex flex-col mb-4" style="border-top: solid 1px #ccc;">
                                                <div class="flex items-center">
                                                    <div class="flex items-center justify-center w-7 h-7 rounded-full">
                                                        <span class="font-bold text-xl">&nbsp;</span>
                                                    </div>
                                                    <div class="w-1/4 min-w-1/4 ml-4 leading-none">
                                                        <!-- Ajusta la anchura aquí -->
                                                        <div class="text-sm font-medium text-secondary">&nbsp;</div>
                                                    </div>
                                                    <div class="w-1/4 ml-4 leading-none">
                                                        <div class="text-sm font-medium text-secondary text-right">
                                                            &nbsp;</div>
                                                    </div>
                                                    <div class="w-1/2 ml-4 leading-none">
                                                        <div class="mt-2 font-bold text-sm text-right">{{
                                                            sumarTotalesTaxes(dataTaxes.traslados) | currency:'MXN'}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-1"></div>
                                        <div class="col-sm-5">
                                            <h5>Retenciones</h5>
                                            <!-- Retenciones -->
                                            <div class="flex flex-col mb-4">
                                                <div class="flex items-center">
                                                    <div class="flex items-center justify-center w-7 h-7 rounded-full">
                                                        <span class="font-bold text-xl">#</span>
                                                    </div>
                                                    <div class="w-1/4 min-w-1/4 ml-4 leading-none">
                                                        <!-- Ajusta la anchura aquí -->
                                                        <div class="text-sm font-medium text-secondary">Impuesto</div>
                                                    </div>
                                                    <div class="w-1/4 ml-4 leading-none">
                                                        <div class="text-sm font-medium text-secondary text-right">
                                                            TasaOFactor</div>
                                                    </div>
                                                    <div class="w-1/2 ml-4 leading-none">
                                                        <div class="text-sm font-medium text-secondary text-right">Total
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="flex flex-col mb-4"
                                                *ngFor="let taxes of dataTaxes.retenciones; let i = index">
                                                <div class="flex items-center">
                                                    <div
                                                        class="flex items-center justify-center w-7 h-7 rounded-full bg-red-100 text-red-800 dark:bg-red-600 dark:text-red-50">
                                                        <span class="font-bold text-xl">{{ taxes.clave }}</span>
                                                    </div>
                                                    <div (click)="verDetalle('1', '2', null, cliente.rfc)"
                                                        style="cursor: pointer;"
                                                        class="w-1/4 min-w-1/4 ml-4 leading-none">
                                                        <!-- Ajusta la anchura aquí -->
                                                        <div class="mt-2 font-medium text-md truncate">{{ taxes.impuesto
                                                            }}</div>
                                                    </div>
                                                    <div class="w-1/4 ml-4 leading-none">
                                                        <div class="mt-2 font-medium text-md text-right">{{ taxes.tasa
                                                            }}</div>
                                                    </div>
                                                    <div class="w-1/2 ml-4 leading-none">
                                                        <div class="mt-2 font-medium text-sm text-right">{{ taxes.total
                                                            | currency:'MXN'}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="flex flex-col mb-4" style="border-top: solid 1px #ccc;">
                                                <div class="flex items-center">
                                                    <div class="flex items-center justify-center w-7 h-7 rounded-full">
                                                        <span class="font-bold text-xl">&nbsp;</span>
                                                    </div>
                                                    <div class="w-1/4 min-w-1/4 ml-4 leading-none">
                                                        <!-- Ajusta la anchura aquí -->
                                                        <div class="text-sm font-medium text-secondary">&nbsp;</div>
                                                    </div>
                                                    <div class="w-1/4 ml-4 leading-none">
                                                        <div class="text-sm font-medium text-secondary text-right">
                                                            &nbsp;</div>
                                                    </div>
                                                    <div class="w-1/2 ml-4 leading-none">
                                                        <div class="mt-2 font-bold text-sm text-right">{{
                                                            sumarTotalesTaxes(dataTaxes.retenciones) | currency:'MXN'}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                                <div class="xl:col-span-2">
                                    <!-- Total por comprobante -->

                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="dataTaxes.grafica?.length == 0">
                            <div
                                class="flex flex-col flex-auto items-center justify-center bg-gray-100 dark:bg-transparent">
                                <mat-icon class="icon-size-18 mt-5" [svgIcon]="'heroicons_outline:users'"></mat-icon>
                                <div class="mt-4 text-xl text-center font-semibold tracking-tight text-secondary mb-8">
                                    Aún no cuenta con información en <br>este periodo seleccionado.</div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="!configured">
        <div class="col-sm-12">
            <div class="card p-4 mt-3" *ngIf="!configured">
                <!-- Icon Section -->
                <div class="d-flex justify-content-center align-items-center rounded-circle bg-primary text-white p-4 mb-4" style="width: 60px; height: 60px; margin: 0 auto;">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon-size-10" style="width: 40px; height: 40px;">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"></path>
                    </svg>
                </div>
            
                <!-- Title Section -->
                <h5 class="card-title text-center">Emisor Requerido</h5>
            
                <!-- Description Section -->
                <p class="card-text text-secondary text-center">
                    Aún no tienes un emisor configurado. Por favor, crea uno para habilitar el acceso a esta sección.
                </p>
            
                <!-- Button Section -->
                <div class="text-center mt-4">
                    <a routerLink="/cuenta/nonecompany" class="btn btn-primary">Crear emisor</a>
                </div>
            </div>
        </div>
    </div>

</div>